import { AxiosResponse, isAxiosError } from 'axios';

export const getAxiosData = <T>(res: AxiosResponse<T>) => res.data;

export const isCanceledAxiosError = (error: unknown) =>
    isAxiosError(error) && error.code === 'ERR_CANCELED';
